<template>
  <Form
    :data-detail="dataDetail"
    action="detail"
  />
</template>

<script>
import { ref } from '@vue/composition-api'
import Form from '@/views/b/ruangan/components/Form.vue'
import apiRuangan from '@/composables/b/ruangan'
import { propsString } from '@/utils/propsTipeData'

export default {
  setup(props, context) {
    const g = context.root

    const dataDetail = ref({})

    const getDetail = async () => {
      const data = {
        guid_aset: props.guidAset,
        kolok: props.kolok,
        filter_kolok: props.kolok,
        kolok_gedung: props.kolok_gedung,
        kobar_108: null,
        nabar_108: null,
      }
      const { data: rows } = await apiRuangan.getDetail(g, data)

      const listLantai = []
      for (let i = 0; i < rows[0].data_ruangan.length; i += 1) {
        const item = rows[0].data_ruangan[i]
        data.kobar_108 = rows[0].kobar_108;
        data.nabar_108 = rows[0].nabar_108;
        const ruangan = []
        for (let j = 0; j < item.ruangan.length; j += 1) {
          const itemRuangan = item.ruangan[j]
          ruangan.push({
            kode: {
              value: itemRuangan.jenis_ruangan_id,
              text: itemRuangan.jenis_ruangan_nama,
            },
            nama: itemRuangan.nama_ruangan,
            id: itemRuangan.ruangan_id,
          })
        }
        listLantai.push({
          value: item.lantai,
          ruangan,
        })
      }

      console.log("ini data",data)

      dataDetail.value = {
        kolok_gedung: props.kolok_gedung,
        kolok: props.kolok,
        register: props.guidAset,
        lantai: listLantai,
        kobar_108: data.kobar_108,
        nabar_108: data.nabar_108,
      }
    }

    getDetail()
    return {
      dataDetail,
    }
  },
  components: {
    Form,
  },
  props: {
    guidAset: propsString,
    kolok: propsString,
    kolok_gedung: propsString,
    kobar_108: propsString,
  },
}
</script>
